'use es6';

import * as feedbackCustomerTypes from './feedback-customer-types';
const oneOffs = [feedbackCustomerTypes];
export const get = (property, config) => oneOffs.find(oneOff => oneOff.precondition(property, config));